export default __webpack_public_path__ + "static/media/cleaning_horizontal_responsive.d61d7ad4.png";